import { Card, Stack, Typography, Switch, Grid } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { toggleVisibility } from "Redux/inventorySlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import DatePicker from "Components/DatePicker";
import TimePicker from "Components/TimePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import { changeDate, changeSurveysFilter } from "Redux/filtersSlice";

export default function Time() {
  const dispatch = useAppDispatch();
  const { date } = useAppSelector((state) => state.filters);

  const handleSetDateRange = (obj: any) => {
    console.log(obj, "bdfbvdvd");
    dispatch(changeDate(obj));
    // dispatch(changeSurveysFilter(obj));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <DatePicker
              label="بازه تاریخ"
              name="date"
              // data={surveys}
              data={date}
              isRange={true}
              setData={(value) => handleSetDateRange(value)}
            />
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
}
